import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Button,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
} from '@mui/material';

const steps = [
  'Basic Information',
  'Contact Information',
  'Additional Information',
  'Communication Authority',
  'Membership Details',
];

export default function IndustryUserViewDialog({ open, onClose, user }) {
  const [activeStep, setActiveStep] = useState(0);

  // Format year of establishment
  const getYear = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).getFullYear().toString();
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>View Industry User</DialogTitle>
      <DialogContent>
        <Stepper activeStep={activeStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {activeStep === 0 && (
          <>
            <TextField 
              label="Organization Name"
              value={user?.organizationName || ''}
              fullWidth 
              margin="normal"
              disabled
            />
            <TextField
              label="Name of CMD/MD/CEO"
              value={user?.nameofcmdOrMdOrCeo || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField 
              label="Email"
              value={user?.email || ''}
              fullWidth 
              margin="normal"
              disabled
            />
            <TextField 
              label="Phone Number"
              value={user?.phoneno || ''}
              fullWidth 
              margin="normal"
              disabled
            />
            <TextField
              label="Address Line 1"
              value={user?.address1 || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField  
              label="Address Line 2"
              value={user?.address2 || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="City"
              value={user?.city || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="State"
              value={user?.state || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Postal Code"
              value={user?.postalCode || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="LinkedIn"
              value={user?.linkedin || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="GST Number"
              value={user?.gstnumber || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="PAN Number"
              value={user?.panNumber || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField 
              label="Year of Establishment"
              value={user?.yearOfEstablishment ? getYear(user.yearOfEstablishment) : ''}
              fullWidth 
              margin="normal"
              disabled
            />
          </>
        )}

        {activeStep === 1 && (
          <>
            <TextField
              label="Nature of Organization"
              value={user?.natureoforganization || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <FormControl fullWidth margin="normal" disabled>
              <InputLabel>Number of Employees</InputLabel>
              <Select
                value={user?.numberOfEmployees || ''}
                label="Number of Employees"
              >
                <MenuItem value="" disabled>Select Number of Employees</MenuItem>
                <MenuItem value="0-50">0-50</MenuItem>
                <MenuItem value="51-100">51-100</MenuItem>
                <MenuItem value="101-500">101-500</MenuItem>
                <MenuItem value="501-1000">501-1000</MenuItem>
                <MenuItem value="1001-5000">1001-5000</MenuItem>
                <MenuItem value="5001-10000">5001-10000</MenuItem>
                <MenuItem value="10001-50000">10001-50000</MenuItem>
                <MenuItem value="50001-100000">50001-100000</MenuItem>
                <MenuItem value="100001 and above">100001 and above</MenuItem>
              </Select>
            </FormControl>
            <TextField 
              label="Registered Office Address"
              value={user?.regdOfficeAddress || ''}
              fullWidth 
              margin="normal"
              disabled
            />
            <TextField 
              label="Factory Address"
              value={user?.factoryAddress || ''}
              fullWidth 
              margin="normal"
              disabled
            />
            <TextField 
              label="Telephone (Office)"
              value={user?.telephoneOffice || ''}
              fullWidth 
              margin="normal"
              disabled
            />
          </>
        )}

        {activeStep === 2 && (
          <>
            <TextField 
              label="Telephone (Factory)"  
              value={user?.telephoneFactory || ''}  
              fullWidth  
              margin="normal" 
              disabled 
            />  
            <TextField 
              label="Website"  
              value={user?.website || ''}  
              fullWidth  
              margin="normal" 
              disabled 
            />  
            <TextField 
              label="Head of HRD"  
              value={user?.headHRD || ''}  
              fullWidth  
              margin="normal" 
              disabled 
            />  
            <TextField 
              label="Head of Operations"  
              value={user?.headOperations || ''}  
              fullWidth  
              margin="normal"  
              disabled
            />  
            <TextField 
              label="Head of Administration"  
              value={user?.headAdministration || ''}  
              fullWidth  
              margin="normal" 
              disabled 
            />  
            <TextField 
              label="Products"  
              value={user?.products || ''}  
              fullWidth   
              margin="normal" 
              disabled  
            />  
            <TextField 
              label="Related Group Industries"  
              value={user?.relatedGroupIndustries || ''}  
              fullWidth   
              margin="normal" 
              disabled  
            />  
            <TextField 
              label="Turnover"  
              value={user?.turnover || ''}  
              fullWidth   
              margin="normal"
              disabled   
            />  
            <TextField 
              label="Achievements"  
              value={user?.achievements || ''}  
              fullWidth   
              margin="normal" 
              disabled  
            />  
            <TextField 
              label="Additional Info"  
              value={user?.additionalInfo || ''}  
              fullWidth   
              multiline
              rows={4}
              margin="normal"
              disabled
            />
          </>
        )}

        {activeStep === 3 && (
          <>
            <TextField 
              label="Communication Authority Name"   
              value={user?.communicationAuthority?.name || ''}   
              fullWidth   
              margin="normal"
              disabled   
            />  
            <TextField 
              label="Communication Authority Designation"   
              value={user?.communicationAuthority?.designation || ''}   
              fullWidth   
              margin="normal" 
              disabled  
            />  
            <TextField 
              label="Communication Authority Phone"   
              value={user?.communicationAuthority?.phone || ''}   
              fullWidth   
              margin="normal" 
              disabled  
            />  
            <TextField 
              label="Communication Authority Email"   
              value={user?.communicationAuthority?.email || ''}   
              fullWidth   
              margin="normal"
              disabled   
            />  
            <TextField
              label="How did you know about us?"
              value={user?.howDidYouKnowAboutUs || ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Membership ID"
              value={user?.membershipID || ''}
              fullWidth
              margin="normal"
              disabled
            />
          </>
        )}

        {activeStep === 4 && (
          <>
            <TextField 
              label="Membership Category"  
              value={user?.membershipCategory || ''}  
              fullWidth   
              margin="normal"
              disabled
            />
            <TextField 
              label="Tenure"  
              value={user?.tenure || ''}  
              fullWidth   
              margin="normal"
              disabled
            />
            <TextField 
              label="MSME Certificate Type"  
              value={user?.msmeCertificateType || ''}  
              fullWidth   
              margin="normal"
              disabled
            />
            {user?.msmeCertificateUpload && (
              <TextField 
                label="MSME Certificate"  
                value="Certificate Uploaded"
                fullWidth   
                margin="normal"
                disabled
                helperText={
                  <a 
                    href={user.msmeCertificateUpload} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    View Certificate
                  </a>
                }
              />
            )}
            {user?.gstCertificateUpload && (
              <TextField 
                label="GST Certificate"  
                value="Certificate Uploaded"
                fullWidth   
                margin="normal"
                disabled
                helperText={
                  <a 
                    href={user.gstCertificateUpload} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    View Certificate
                  </a>
                }
              />
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        {activeStep > 0 && (
          <Button onClick={handleBack}>Back</Button>
        )}
        
        {activeStep < steps.length - 1 && (
          <Button onClick={handleNext}>Next</Button>
        )}
        
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}